export { DetailPage, DetailPageViewContext } from './DetailPage'
export type {
  DetailPageAsideProps,
  DetailPageHeaderProps,
  DetailPageProps,
  DetailPageSectionProps,
} from './DetailPage.types'
